import request from '@/utils/request'

export function validateCode(data) {
  return request({
    url: '/api/v1/verification-codes/verify',
    method: 'post',
    data
  })
}

export function confirmAndExecute(data) {
  return request({
    url: '/api/v1/verification-codes/confirm',
    method: 'post',
    data
  })
} 